window.bootstrap = require('bootstrap/dist/js/bootstrap.bundle.js');


document.addEventListener("DOMContentLoaded", function () {


	document.querySelectorAll(".sidebar .nav-link").forEach(function(element) {

		element.addEventListener("click", function (e) {
			let firstEl = element.nextElementSibling;
			let nextEl = firstEl.children[0];
			let parentEl = element.parentElement;
			if (nextEl) {
				e.preventDefault();
				let mycollapse = new bootstrap.Collapse(nextEl);

				if (nextEl.classList.contains("show")) {
					mycollapse.hide();
				} else {
					mycollapse.show();
					// find other submenus with class=show
					var opened_submenu =
						parentEl.parentElement.querySelector(".submenu.show");
					// if it exists, then close all of them
					if (opened_submenu) {
						new bootstrap.Collapse(opened_submenu);
					}
				}
			}
		}); // addEventListener

		if ((document.querySelector(".toc-list-item") != null) && (window.screen.width <= 768)) {
			document.querySelectorAll( ".toc-list-item" ).forEach(function( sa ) {
				sa.addEventListener("click", function (e) {
					let firstEl = element.nextElementSibling;
					let nextEl = firstEl.children[0];
					let parentEl = element.parentElement;
					if (nextEl) {
						e.preventDefault();
						let mycollapse = new bootstrap.Collapse(nextEl);

						if (nextEl.classList.contains("show")) {
							mycollapse.hide();
						} else {
							mycollapse.show();
							// find other submenus with class=show
							var opened_submenu =
								parentEl.parentElement.querySelector(".submenu.show");
							// if it exists, then close all of them
							if (opened_submenu) {
								new bootstrap.Collapse(opened_submenu);
							}
						}
					}
				}); // addEventListener

			} );
		}

	}); // forEach
});
// DOMContentLoaded  end
